module.exports = __webpack_public_path__ + "img/cost_icon_certificada.4b59d2ff.svg";